import axios from 'axios';

// Typeahead suggestions from the server-side proxy. Server forwards the
// partial query to Smarty. Provider credentials stay server-side; only the
// address fragment the user typed leaves the server.
export async function suggestAddress(query, { signal } = {}) {
  if (!query || query.trim().length < 3) return [];
  const res = await axios.get('/address/suggest', {
    params: { q: query.trim() },
    signal,
  });
  return res?.data?.suggestions || [];
}

// Verify + geocode a picked address. Returns { ok, suggestion } where
// `suggestion` carries canonical components + lat/lng. Required after pick
// because Smarty's autocomplete doesn't ship coordinates — the verify call
// is what fetches them.
export async function validateAddress(address, { signal } = {}) {
  const res = await axios.post('/address/validate', address, { signal });
  return res?.data || { ok: false, suggestion: null };
}
